import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { NetworkStatusInfoComponent } from '@core/components';
import { NavbarMobileComponent } from '@core/components/navbar-mobile/navbar-mobile.component';
import { LocaleService } from '@core/localization/locale.service';
import { LocalizationModule } from '@core/localization/localization.module';
import { MaterialModule } from '@root/material';
import { SharedModule } from '@shared/shared.module';
import { AppComponent } from './containers';
import { CurrencyInitService } from './services';


@NgModule({
    declarations: [AppComponent],
    exports: [AppComponent],
    imports: [
        SharedModule,
        MaterialModule,
        RouterModule,
        NetworkStatusInfoComponent,
        NavbarMobileComponent,
        LocalizationModule,
    ],
    providers: [CurrencyInitService, MatDatepickerModule, LocaleService, provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {
}
